import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuOpen } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import useMenuStorage, { MainMenuItemCategory } from "../../services/menu/MenuStorageService";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  menuOpen: boolean;
  setMenuOpen: (menuOpen: boolean) => void;
}
export default observer(function NavbarMenu({ menuOpen, setMenuOpen }:Props) {
  const navigate = useNavigate();
  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const {menuCategories} = useMenuStorage();
  
  const {pathname} = useLocation();

  const toggleMenu = useCallback(() => setMenuOpen(!menuOpen), [menuOpen]);

  const itemSelected = useCallback(
    (path: string) => pathname.includes(path),
    [pathname]
  );

  const goToPath = useCallback((path: string) => {
      navigate(path);
  }, [])

  return (
    <>
      <IconButton onClick={toggleMenu} sx={{ mx: 3 }}>
        {menuOpen ? <MenuOpen color="primary" /> : <MenuIcon color="primary" />}
      </IconButton>
      <Drawer
        variant="permanent"
        sx={{mt:10}}
        PaperProps={{ sx: { backgroundColor: "#212121", zIndex: -1 } }}
      >
        <Toolbar />
        <List>
          {menuCategories.map((item: any) => (
            <>
              {item.hide && <></>}
              {item.withDivider && <Divider sx={{ borderColor: "white" }} />}
              {!item.hide &&
              <ListItem key={item.name}>
                <Tooltip
                  title={translationService.translate("general." + item.name)}
                  placement="right"
                >
                  <ListItemButton
                    sx={{ display: "flex", alignItems: "center", p: 0 }}
                    onClick={() => {
                      if (item.name === "smart-manager") {
                        openInNewTab(item.path);
                      } else {
                        goToPath(item.path);
                      }
                    }}
                  >
                    <ListItemIcon>
                      {itemSelected(item.path) ? item.iconSelected : item.icon}
                    </ListItemIcon>
                    {menuOpen && (
                      <ListItemText>
                        <Typography noWrap
                          color={itemSelected(item.path) ? "primary" : "white"}
                        >
                          {translationService.translate("general." + item.name)}
                        </Typography>
                      </ListItemText>
                    )}
                  </ListItemButton>
                </Tooltip>
              </ListItem>}
            </>
          ))}
        </List>
      </Drawer>
    </>
  );
});
